import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { getAppRolesByAppId } from "api/index.js";
import _ from "lodash";
import { selectGlobal } from "reducers/global";

export const fetchRoles = createAsyncThunk(
	"role/fetchRoles",
	async (_, { getState, rejectWithValue }) => {
		try {
			const { appId }  = selectGlobal(getState());
			const data = await getAppRolesByAppId({ appId });
			return data;
		} catch (error) {
			console.log(error.message);
			return rejectWithValue({
				title: error.name,
				message: error.message,
			});
		}
	}
);

const initialState = {
	roles: [],
	status: "idle",
	error: null,
};

const roleSlice = createSlice({
	name: "assetRc",
	initialState,
	extraReducers: {
		[fetchRoles.pending]: (state, action) => {
			state.status = "loading";
		},
		[fetchRoles.fulfilled]: (state, action) => {
			state.status = "idle";
			const sortedRoles = _.orderBy(
				action.payload,
				["roleName"],
				["asc"]
			);
			state.roles = sortedRoles;
		},
		[fetchRoles.rejected]: (state, action) => {
			state.status = "failed";
			state.error = action.payload;
			state.roles = [];
		},
	},
});

export const selectAllRoles = (state) => state.capex.role.roles;

export default roleSlice.reducer;
